import { connect } from 'react-redux'

import {
    fetchMediaPage,
} from '../../actions/Media'

import MediaPage from '../../components/Media/MediaPage/MediaPage'

const mapStateToProps = (state) => ({
    data: state.media.data,
    title: state.media.title,

    isError: state.media.isError,
    isErrorNotFound: state.media.isErrorNotFound,
    isFetching: state.media.isFetching,
    isFetched: state.media.isFetched,
})

const mapDispatchToProps = (dispatch) => ({
    fetchMediaPage: (slug) => {
        dispatch(fetchMediaPage(slug))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(MediaPage)
